module.exports = __webpack_public_path__ + "static/media/club_join.e2171a61.png";